<template>
  <div v-loading="coursePlanLoading" class="course-plan-box">
    <div class="plan-header">
      <el-form ref="form" :inline="true" label-width="80px">
        <el-form-item label="自动排课">
          <el-switch v-model="coachInfo.is_auto_plan_lesson" :active-value="1" active-text="开" :inactive-value="0" inactive-text="关" @change="setAutoPlan"></el-switch>
        </el-form-item>
      </el-form>
    </div>

    <div class="user-defined-table2">
      <div class="user-defined-tr">
        <div v-for="(week,index) in weeks" :key="index" class="user-defined-td user-defined-th">
          <template v-if="index === 0">
            <div class="header-div">
              <div class="header-col1">时间段</div>
              <div class="header-col2">星期</div>
              <div class="header-line2"></div>
            </div>
          </template>
          <template v-else>
            <div>{{ week }}</div>
          </template>
        </div>
      </div>
      <div v-for="(time,tindex) in timeList" v-if="timeList[tindex + 1]" :key="tindex" class="user-defined-tr">
        <div v-for="(week,index) in weeks" :key="index" class="user-defined-td">
          <div v-if="index === 0" class="course-all-list">
            {{ time }} ~ {{ timeList[tindex + 1] }}
          </div>
          <div v-else class="course-all-list">
            <el-button type="text" :style="lessonPlanList[index+'_'+time+'_'+timeList[tindex + 1]]?'':'color:#999;'" @click="siteShow(index,time,timeList[tindex + 1])">
              {{ lessonPlanList[index+'_'+time+'_'+timeList[tindex + 1]]&&lessonPlanList[index+'_'+time+'_'+timeList[tindex + 1]].site_name?lessonPlanList[index+'_'+time+'_'+timeList[tindex + 1]].site_name:'选择上课门店' }}
            </el-button>
          </div>

        </div>

      </div>
    </div>
    <!--排课计划-->
    <el-dialog title="门店列表" :visible.sync="dialogSitesVisible" width="600px" top="15vh" :append-to-body="true" @close="siteclose">
      <el-table ref="siteSingleTable" highlight-current-row :data="siteList" max-height="50vh" @current-change="handleCurrentChange">
        <el-table-column property="name" label="门店名称"></el-table-column>
        <el-table-column width="150" align="center" prop="type_name" label="门店类型"> </el-table-column>
        <el-table-column width="150" align="center" prop="open_status" label="是否营业">
          <template slot-scope="{ row }">
            {{ row.open_status === 1 ? '休息' : '营业' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectCancleSite">取消选择</el-button>
        <el-button type="primary" @click="selectSite">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import commonList from '@/utils/commonList'
import coachApi from '@/api/coach/coach' // 和数据交互相关写在api 方便复用

export default {
  name: 'LessonPlan',
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogSitesVisible: false,
      api,
      coursePlanLoading: false,
      coachInfo: {},
      dates: [],
      weeks: ['', '一', '二', '三', '四', '五', '六', '日'],
      timeList: [],
      lessonPlanList: {},
      siteList: [],
      currentCell: {},
      currentSiteRow: {}

    }
  },
  beforeMount() {

  },
  mounted() {
    this.getCoachInfo()
    this.getTimeList()
    // this.getCoachList()
    this.getDatePlan()
  },
  methods: {
    selectCancleSite() {
      const currentKey = this.currentCell.week + '_' + this.currentCell.time + '_' + this.currentCell.end_time
      if (this.lessonPlanList[currentKey]) {
        delete this.lessonPlanList[currentKey]
        this.dialogSitesVisible = false
        this.siteclose()
      }
    },
    setAutoPlan(type) {
      coachApi.setAutoPlan({
        id: this.coachId,
        is_auto_plan_lesson: type
      }).then(() => {
        this.coachInfo.is_auto_plan_lesson = type
      })
    },
    // 教练信息
    getCoachInfo() {
      coachApi.Detail(this.coachId).then(res => {
        this.coachInfo = res.data
      })
    },
    // 获取时间段
    getTimeList() {
      this.timeList = []
      api.getBusinessTime().then((res) => {
        const start_time = Number(res.data.business_start_time.split(':')[0])
        const end_time = Number(res.data.business_end_time.split(':')[0])
        for (let i = start_time; i <= end_time; i++) {
          if (i < 10) {
            this.timeList.push('0' + i + ':00')
          } else {
            this.timeList.push(i + ':00')
          }
        }
      })
    },
    getDatePlan() {
      this.coursePlanLoading = true
      api.getPlan({
        coach_id: this.coachId
      }).then(res => {
        this.lessonPlanList = res.data
        this.coursePlanLoading = false
      }).catch(() => { this.coursePlanLoading = false })
    },
    siteShow(week, time, end_time) {
      coachApi.SiteList({
        coach_id: this.coachId,
        time: time + ' ~ ' + end_time
      }).then(response => {
        this.currentCell = {
          week,
          time,
          end_time
        }
        this.siteList = response.data
        this.dialogSitesVisible = true
        this.$nextTick(() => {
          if (this.currentCell) {
            const currentKey = this.currentCell.week + '_' + this.currentCell.time + '_' + this.currentCell.end_time
            if (this.lessonPlanList[currentKey]) {
              for (const i in this.siteList) {
                if (this.lessonPlanList[currentKey].site_id === this.siteList[i].id) {
                  this.$refs.siteSingleTable.setCurrentRow(this.siteList[i])
                }
              }
            }
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.currentSiteRow = val
    },
    selectSite() {
      const currentKey = this.currentCell.week + '_' + this.currentCell.time + '_' + this.currentCell.end_time
      this.lessonPlanList[currentKey] = {
        site_id: this.currentSiteRow.id,
        site_name: this.currentSiteRow.name,
        time: this.currentCell.time,
        time_end: this.currentCell.end_time,
        week: this.currentCell.week
      }

      this.dialogSitesVisible = false
      this.siteclose()
    },
    siteclose() {
      this.listQuery = {
        page: 1,
        limit: 6,
        order: 'ASC',
        sort: 'order_no'
      }
      this.currentCell = {}
      this.currentSiteRow = null
      // this.$refs.siteSingleTable.setCurrentRow()
    }

  }
}
</script>
<style>
.user-defined-table2{
    width:100%;
    height:500px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dfe6ec;
    border-top: 1px solid #dfe6ec;
  }
  .user-defined-tr{
    display: flex;
  }
  .user-defined-td{
    width:12.5%;
    padding: 10px;
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    border-right: 1px solid #dfe6ec;
    border-bottom: 1px solid #dfe6ec;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .user-defined-th{
    font-weight: 600;
  }
  .header-div {
    width:100%;
    position: relative;
  }
  .header-col1 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .header-col2 {
    position: absolute;
    right: 0;
    top: 0;
  }
  .header-line2 {
    padding-left: 0;
    width: 1px;
    height: 120px;
    transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
    -webkit-transform-origin: top;
    transform-origin: top;
    background-color: #fff;
    border-left:1px solid #e5e5e5;
  }
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}
/deep/ .el-dialog .el-dialog__body{
  padding-top:0 !important;
}
.el-table::before{
  height:0 !important;
}

.course-plan-box{
  width: 1150px;
  margin:20px auto;
  margin-top:0px;
  height:60vh;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-container{
    padding-bottom:0 !important;
  }

</style>
